var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBullseye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 854 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 854,
    height: 480,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.32,480H0V0H148.32a367.78,367.78,0,0,0,0,480ZM705.68,0a367.78,367.78,0,0,1,0,480H854V0Z",
    fill: "#ff0089"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M269,480H180.06a344.31,344.31,0,0,1,0-480H269C191.1,51.39,139.68,139.68,139.68,240S191.1,428.61,269,480ZM714.32,240c0,100.32-51.42,188.61-129.33,240h89a344.31,344.31,0,0,0,0-480H585C662.9,51.39,714.32,139.68,714.32,240Z",
    fill: "#ff0089",
    opacity: 0.95
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M427,10.37C300.18,10.37,197.37,113.18,197.37,240S300.18,469.63,427,469.63,656.63,366.82,656.63,240,553.82,10.37,427,10.37Zm0,413.75c-101.68,0-184.12-82.44-184.12-184.12S325.32,55.88,427,55.88,611.12,138.32,611.12,240,528.68,424.12,427,424.12Z",
    fill: "#ff0089",
    opacity: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M427,132.88A107.12,107.12,0,1,0,534.12,240,107.12,107.12,0,0,0,427,132.88Zm0,187.7A80.58,80.58,0,1,1,507.58,240,80.58,80.58,0,0,1,427,320.58Z",
    fill: "#ff0089",
    opacity: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullseye);
export default __webpack_public_path__ + "static/media/Bullseye.beee4e9df6cd33612d6769b675f222ce.svg";
export { ForwardRef as ReactComponent };